import styled, { css } from 'styled-components'
import { fadeOut, fadeIn, slideUp, slideDown } from '../../GlobalStyles'
import { StyledModalHeader } from './ModalHeader/styles'

export const modalSizes = {
  xm: '30vw',
  sm: '40vw',
  md: '50vw',
  lg: '70vw',
  xl: '90vw',
  fit: 'fit-content',
  max: 'max-content',
  min: 'min-content',
  auto: 'auto'
}

const footerAlignMap = {
  start: 'flex-start',
  center: 'center',
  end: 'flex-end'
}

export const ModalTitle = styled.div`
  ${({ align }) => css`
    font-size: 1.2rem;
    font-weight: 700;
    text-align: ${align || 'start'};
    white-space: pre-line;
    width: 100%;

    @media (max-width: 390px) {
      font-size: 1rem;
    }
  `}
`

export const ModalBody = styled.div`
  overflow-x: auto;
  padding: 0 1.5rem;
`

export const ModalFooter = styled.div`
  ${({ align = 'start' }) => css`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 1rem;
    height: 100%;
    justify-content: ${footerAlignMap[align]};
    min-width: min-content;
    padding: 1.5rem;
    width: 100%;
  `}
`

export const Backdrop = styled.div`
  ${({ show }) => css`
    align-items: center;
    animation: ${!show ? fadeOut : fadeIn} 0.3s alternate;
    background-color: rgba(196, 196, 196, 0.7);
    display: flex;
    height: 100%;
    justify-content: center;
    left: 0;
    opacity: ${!show ? '0' : '1'};
    overflow-y: scroll;
    overscroll-behavior: none;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: var(--z-index-modal-backdrop);

    ::-webkit-scrollbar {
      display: none;
    }

    ::before {
      content: '';
      height: calc(100% + 1px);
    }
  `}
`

export const ModalDialog = styled.dialog`
  ${({ size = 'sm', show, variant }) => css`
    animation: ${!show ? slideUp : slideDown} 0.3s alternate;
    background: var(--background);
    border: none;
    border-radius: var(--border-radius-lg);
    display: initial;
    margin: auto;
    min-width: min-content;
    padding: 0;
    position: relative;
    width: ${modalSizes[size]};

    @media (min-width: 576px) {
      max-width: 540px;
    }

    @media (min-width: 768px) {
      max-width: 720px;
    }

    @media (min-width: 992px) {
      max-width: 960px;
    }

    @media (min-width: 1200px) {
      max-width: 1140px;
    }

    @media (max-width: 1439px) {
      width: 50vw;
    }

    @media (max-width: 991px) {
      width: 90vw;
    }

    @media (max-width: 575px) {
      min-width: calc(100vw - 2rem);
    }

    /* Bordas de cima */
    > div:first-child {
      border-radius: calc(var(--border-radius-lg) - 1px);
    }

    /* Bordas de baixo */
    > div:last-child {
      border-radius: 0 0 calc(var(--border-radius-lg) - 1px)
        calc(var(--border-radius-lg) - 1px);
    }

    /* Único filho */
    > div:only-child {
      border-radius: calc(var(--border-radius-lg) - 1px)
        calc(var(--border-radius-lg) - 1px);
    }

    /* Children adjustments */
    > ${ModalBody}, ${StyledModalHeader} {
      /* Gradient filter */
      ${!!variant &&
      css`
        * {
          color: var(--text-light);
        }
        border: none;
        color: var(--text-light);
      `}
    }
  `}
`

export const ModalContainer = styled.div`
  ${({ display, align, justify, padding, margin, width }) => css`
    ${display === 'grid'
      ? css`
          display: grid;
          grid-template-columns: ${justify === 'center' ? '1fr' : 'auto'};
          grid-template-rows: ${align === 'center' ? '1fr' : 'auto'};
          grid-gap: ${padding || '1rem'};
          margin: ${margin || '0'};
        `
      : css`
          display: flex;
          flex-direction: ${display === 'column' ? 'column' : 'row'};
          justify-content: ${justify || 'start'};
          align-items: ${align || 'start'};
          padding: ${padding || '0'};
          margin: ${margin || '0'};
        `}
    width: ${width || 'auto'};
  `}
`
